import { ErrorModal } from "components/modals/ErrorModal";
import { SimpleModal } from "components/modals/SimpleModal"
import { TokenDetailModal } from "components/modals/TokenDetailModal";
import { RegisteredTokenDetail } from "models/factory/RegisteredTokenResponse";
import { ConfigResponse } from "models/staking/ConfigResponse";
import { TokenInfoResponse } from "models/token/TokenInfoResponse";
import { ReactNode } from "react";
import { createRoot, Root } from "react-dom/client";

let modalRoot: Root | null = null;

const triggerModal = (id: string) => {
  const btn = document.getElementById("modal-trigger")
  btn?.setAttribute('data-bs-target', id)
  btn?.click();
}

export const showSimpleModal = (title: string, content: any) => {
  const id = "#small-modal"
  const modal = document.querySelector(id)!

  if (!modalRoot) modalRoot = createRoot(modal.querySelector(".modal-dialog")!);
  modalRoot.render(<SimpleModal title={title} content={content} />)

  triggerModal(id)
}

export const showErrorModal = (message: string) => {
  const id = "#small-modal"
  const modal = document.querySelector(id)!

  if (!modalRoot) modalRoot = createRoot(modal.querySelector(".modal-dialog")!);
  modalRoot.render(<ErrorModal message={message} />)

  triggerModal(id)
}

export const showTokenDetailModal = (tokenInfo?: TokenInfoResponse, config?: ConfigResponse, tokenDetail?: RegisteredTokenDetail, pool?: number) => {
  const id = "#large-modal"
  const modal = document.querySelector(id)!

  if (!modalRoot) modalRoot = createRoot(modal.querySelector(".modal-dialog")!);
  modalRoot.render(<TokenDetailModal tokenDetail={tokenDetail} config={config} tokenInfo={tokenInfo} pool={pool} />)

  triggerModal(id)
}